import { all, call, put, takeLatest } from 'redux-saga/effects'

import { JobActionTypes } from 'helpers/constants/action_types/job'
import { JobActions } from 'store/actions/job'
import ProjectHelpers from 'helpers/project_helpers'
import ErrorHelpers from 'helpers/errors_helper'
import StripeHelpers from 'helpers/stripe_helpers'

function* watchFetch() {
  yield takeLatest(JobActionTypes.FETCH, function* ({ payload }) {
    try {
      const response = yield call(ProjectHelpers.loadJobAsync, payload)

      yield put(JobActions.FETCH_SUCCESS(response))
    } catch (error) {
      yield put(JobActions.FETCH_FAILURE())
    }
  })
}

function* watchFetchBySecretAliasId() {
  yield takeLatest(JobActionTypes.FETCH_BY_SECRET_ALIAS_ID, function* ({ payload }) {
    try {
      const response = yield call(ProjectHelpers.loadJobBySecretAliasIdAsync, payload)
      yield put(JobActions.FETCH_BY_SECRET_ALIAS_ID_SUCCESS(response))
    } catch (error) {
      yield put(JobActions.FETCH_BY_SECRET_ALIAS_ID_FAILURE())
    }
  })
}

function* watchUpdate() {
  yield takeLatest(JobActionTypes.UPDATE, function* ({ id, payload, onSuccessCallback, onErrorCallback = () => {} }) {
    try {
      const response = yield call(ProjectHelpers.updateJobAsync, payload, id)

      yield put(JobActions.UPDATE_SUCCESS(response))
      onSuccessCallback()
    } catch (error) {
      alert(ErrorHelpers.normalizeError(error))
      yield put(JobActions.UPDATE_FAILURE())
      onErrorCallback()
    }
  })
}

function* watchToggleSelection() {
  yield takeLatest(JobActionTypes.TOGGLE_TALENT_SELECTION, function* ({ id }) {
    try {
      const response = yield call(ProjectHelpers.toggleFinishTalentSelectionAsync, id)

      yield put(JobActions.TOGGLE_TALENT_SELECTION_SUCCESS(response))
    } catch (error) {
      alert(ErrorHelpers.normalizeError(error))
      yield put(JobActions.TOGGLE_TALENT_SELECTION_FAILURE())
    }
  })
}

function* watchCancel() {
  yield takeLatest(JobActionTypes.CANCEL, function* ({ job, onErrorCallback }) {
    try {
      yield call(ProjectHelpers.cancelJobAsync, job)

      yield put(JobActions.CANCEL_SUCCESS())
    } catch (error) {
      yield put(JobActions.CANCEL_FAILURE())
      onErrorCallback(error.statusText || 'Error', error.responseJSON.exception || 'Oops, something went wrong')
    }
  })
}

function* watchSelectApplicant() {
  yield takeLatest(JobActionTypes.SELECT, function* ({ jobId, selectedApplicantId, paymentInfo, onSuccessCallback }) {
    try {
      const response = yield call(ProjectHelpers.selectApplicantAsync, jobId, selectedApplicantId, paymentInfo)

      yield put(JobActions.SELECT_SUCCESS(response))
      onSuccessCallback()
    } catch (error) {
      alert(ErrorHelpers.normalizeError(error))
      yield put(JobActions.SELECT_FAILURE())
    }
  })
}

function* watchDeSelectApplicant() {
  yield takeLatest(JobActionTypes.DESELECT, function* ({ jobId, applicantId, onSuccessCallback }) {
    try {
      yield call(ProjectHelpers.deSelectApplicantAsync, jobId, applicantId)
      yield put(JobActions.DESELECT_SUCCESS(applicantId))
      if (onSuccessCallback) onSuccessCallback()
    } catch (error) {
      alert(ErrorHelpers.normalizeError(error))
      yield put(JobActions.DESELECT_FAILURE())
    }
  })
}

function* watchRetryPayment() {
  yield takeLatest(JobActionTypes.RETRY_PAYMENT, function* ({ jobId, paymentMethodId, onSuccessCallback, onErrorCallback }) {
    try {
      const response = yield call(StripeHelpers.capturePaymentIntent, jobId, paymentMethodId)
      yield put(JobActions.RETRY_PAYMENT_SUCCESS())
      onSuccessCallback(response)
    } catch (error) {
      yield put(JobActions.RETRY_PAYMENT_FAILURE())
      onErrorCallback(error.message || 'Error processing payment' + ErrorHelpers.ERROR_CONTACT_SUPPORT)
    }
  })
}

export default function* jobSaga() {
  yield all([
    watchFetch(),
    watchFetchBySecretAliasId(),
    watchUpdate(),
    watchToggleSelection(),
    watchCancel(),
    watchSelectApplicant(),
    watchDeSelectApplicant(),
    watchRetryPayment(),
  ])
}
